import React, { useEffect, useState, useRef, createElement } from 'react';
import { LayoutDashboardIcon, PencilRulerIcon, DollarSignIcon, ShoppingCartIcon, UsersIcon, BadgeIcon, WarehouseIcon, HeadphonesIcon, SettingsIcon, UserIcon, LogOutIcon, BarChart3Icon, HomeIcon, ChevronLeftIcon, ChevronRightIcon, PencilIcon, GlobeIcon, RulerIcon, CheckIcon, ChevronUpIcon, BuildingIcon, XIcon, SparklesIcon, WrenchIcon, BugIcon, HeartIcon } from 'lucide-react';
import { EditProfileModal } from './EditProfileModal';
import { EditCompanyModal } from './EditCompanyModal';
import { useUser } from '../contexts/UserContext';
const languages = [{
  code: 'en',
  name: 'English',
  flag: '🇺🇸'
}, {
  code: 'es',
  name: 'Español',
  flag: '🇪🇸'
}, {
  code: 'fr',
  name: 'Français',
  flag: '🇫🇷'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}, {
  code: 'pt',
  name: 'Português',
  flag: '🇵🇹'
}];
const unitSystems = [{
  id: 'metric',
  name: 'Métrico',
  description: 'km, kg, °C'
}, {
  id: 'imperial',
  name: 'Imperial',
  description: 'mi, lb, °F'
}];
export function Sidebar({
  onNavigate,
  activePage = 'home',
  collapsed = false,
  onToggleSidebar
}) {
  const [changelogOpen, setChangelogOpen] = useState(false);
  const toggleSidebar = () => {
    if (onToggleSidebar) {
      onToggleSidebar();
    }
  };
  return <div className={`${collapsed ? 'w-[72px]' : 'w-[208px]'} bg-gradient-to-b from-blue-950 to-teal-900 text-white flex flex-col h-screen sticky top-0 left-0 transition-all duration-300 ease-in-out relative group overflow-visible z-50`} data-id="element-6307">
      <div className="p-5 flex flex-col items-center pt-[20px] pb-[0px] pl-[20px] pr-[20px]" data-id="element-6308">
        <div className="flex items-center" data-id="element-6309">
          {collapsed ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cZrMyYGysL7x2nzbnxUSuo/White_Drop_for_Whatsapp.png" alt="Aisco Logo" className="h-7 w-auto transition-all duration-300" data-id="element-6310" /> : <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j7rsd4nQRUtzsXBFyA8c5B/AISCO_WORKSPACE_MARCA_NEGATIVO.svg" alt="Aisco Logo" className="h-9 w-auto filter brightness-0 invert transition-all duration-300" data-id="element-6311" />}
        </div>
        <button onClick={() => setChangelogOpen(true)} className="mt-0.5 text-blue-300/60 hover:text-blue-200 transition-colors cursor-pointer text-[12px]" title="View changelog" data-id="element-6312">
          {collapsed ? 'v3.1' : 'v3.1.0'}
        </button>
      </div>
      <nav className="flex-1 px-3 py-4 overflow-y-auto no-scrollbar" data-id="element-6313">
        <SidebarItem icon={<HomeIcon size={20} data-id="element-6315" />} label="Inicio" active={activePage === 'home'} onClick={() => onNavigate('home')} collapsed={collapsed} data-id="element-6314" />
        <SidebarItem icon={<LayoutDashboardIcon size={20} data-id="element-6317" />} label="Dashboard" active={activePage === 'dashboard'} onClick={() => onNavigate('dashboard')} collapsed={collapsed} data-id="element-6316" />
        <SidebarItem icon={<PencilRulerIcon size={20} data-id="element-6319" />} label="Design" active={activePage === 'design'} onClick={() => onNavigate('design')} collapsed={collapsed} data-id="element-6318" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6321" />} label="Quotes" active={activePage === 'quotes'} onClick={() => onNavigate('quotes')} collapsed={collapsed} data-id="element-6320" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6323" />} label="Quotes V2" active={activePage === 'quotes-v2'} onClick={() => onNavigate('quotes-v2')} collapsed={collapsed} data-id="element-6322" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6325" />} label="Quotes V3" active={activePage === 'quotes-v3'} onClick={() => onNavigate('quotes-v3')} collapsed={collapsed} data-id="element-6324" />
        <SidebarItem icon={<DollarSignIcon size={20} data-id="element-6327" />} label="Quote V4" active={activePage === 'quotes-v4'} onClick={() => onNavigate('quotes-v4')} collapsed={collapsed} data-id="element-6326" />
        <SidebarItem icon={<ShoppingCartIcon size={20} data-id="element-6329" />} label="Order" active={activePage === 'order'} onClick={() => onNavigate('order')} collapsed={collapsed} data-id="element-6328" />
        <SidebarItem icon={<UsersIcon size={20} data-id="element-6331" />} label="Dealers" active={activePage === 'dealers'} onClick={() => onNavigate('dealers')} collapsed={collapsed} data-id="element-6330" />
        <SidebarItem icon={<BadgeIcon size={20} data-id="element-6333" />} label="Subscription" active={activePage === 'subscription'} onClick={() => onNavigate('subscription')} collapsed={collapsed} data-id="element-6332" />
        <SidebarItem icon={<WarehouseIcon size={20} data-id="element-6335" />} label="Warehouses" active={activePage === 'warehouses'} onClick={() => onNavigate('warehouses')} collapsed={collapsed} data-id="element-6334" />
        <SidebarItem icon={<HeadphonesIcon size={20} data-id="element-6337" />} label="Customer support" active={activePage === 'support'} onClick={() => onNavigate('support')} collapsed={collapsed} data-id="element-6336" />
        {/* New Business Intelligence (empty, for redesign) */}
        <SidebarItem icon={<BarChart3Icon size={20} data-id="element-6339" />} label="Business Intelligence" active={activePage === 'business-intelligence-v2'} onClick={() => onNavigate('business-intelligence-v2')} collapsed={collapsed} data-id="element-6338" />
        {/* BI v1 with cyborg icon and special styling */}
        <div className={`flex items-center px-3 py-2 my-1 rounded cursor-pointer transition-colors relative
            bg-gradient-to-r from-purple-600 to-blue-600 shadow-lg
            ${collapsed ? 'justify-center' : ''}
            animate-pulse
          `} onClick={() => onNavigate('business-intelligence')} title={collapsed ? 'BI v1' : ''} data-id="element-6340">
          <div className={`${collapsed ? '' : 'mr-3'} text-white flex-shrink-0 relative`} data-id="element-6341">
            <div className="absolute inset-0 bg-gradient-to-b from-blue-950 to-teal-900 opacity-0 rounded-full" data-id="element-6342"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eJcyBj2puhjmA95iiZVfaB/cyborg.svg" alt="BI v1" className="w-5 h-5 filter brightness-0 invert relative z-10" data-id="element-6343" />
          </div>
          {!collapsed && <span className="text-sm font-bold text-white pr-2 leading-tight" data-id="element-6344">
              BI v1
            </span>}
        </div>
        <SidebarItem icon={<PencilRulerIcon size={20} data-id="element-6346" />} label="iCAD" active={activePage === 'icad'} onClick={() => onNavigate('icad')} collapsed={collapsed} data-id="element-6345" />
        <SidebarItem icon={<BarChart3Icon size={20} data-id="element-6348" />} label="Admin" active={activePage === 'admin'} onClick={() => onNavigate('admin')} collapsed={collapsed} data-id="element-6347" />
      </nav>
      {/* User Avatar Menu at bottom */}
      <UserAvatarMenu collapsed={collapsed} onNavigate={onNavigate} activePage={activePage} data-id="element-6349" />
      <button onClick={toggleSidebar} className="absolute -right-3 top-1/2 transform -translate-y-1/2 bg-blue-800 text-white p-1.5 rounded-full shadow-lg hover:bg-blue-700 transition-colors opacity-0 group-hover:opacity-100" data-id="element-6350">
        {collapsed ? <ChevronRightIcon size={16} data-id="element-6351" /> : <ChevronLeftIcon size={16} data-id="element-6352" />}
      </button>

      {/* Changelog Modal */}
      {changelogOpen && <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={e => {
      if (e.target === e.currentTarget) setChangelogOpen(false);
    }} data-id="element-6353">
          <div className="bg-[#0f1d3a] rounded-2xl shadow-2xl border border-white/10 w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden" data-id="element-6354">
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 flex-shrink-0" data-id="element-6355">
              <div data-id="element-6356">
                <h2 className="text-white font-semibold text-lg" data-id="element-6357">What's New</h2>
                <p className="text-blue-300 text-xs mt-0.5" data-id="element-6358">
                  Version 3.1.0 — April 2026
                </p>
              </div>
              <button onClick={() => setChangelogOpen(false)} className="text-blue-300 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-6359">
                <XIcon size={20} data-id="element-6360" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-6 no-scrollbar" data-id="element-6361">
              {/* New Features */}
              <div data-id="element-6362">
                <div className="flex items-center gap-2 mb-3" data-id="element-6363">
                  <div className="w-7 h-7 rounded-lg bg-emerald-500/20 flex items-center justify-center" data-id="element-6364">
                    <SparklesIcon size={14} className="text-emerald-400" data-id="element-6365" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6366">
                    New Features
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6367">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6368">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6369"></span>
                    System Settings page with Dealer Information, Design
                    Preferences, and Quote tabs
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6370">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6371"></span>
                    Design Preferences: configure default properties for new
                    machine designs
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6372">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6373"></span>
                    Business Intelligence dashboard with advanced analytics
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6374">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-emerald-400 flex-shrink-0" data-id="element-6375"></span>
                    Dealer mark-up configuration with per-customer override
                    support
                  </li>
                </ul>
              </div>

              {/* Improvements */}
              <div data-id="element-6376">
                <div className="flex items-center gap-2 mb-3" data-id="element-6377">
                  <div className="w-7 h-7 rounded-lg bg-blue-500/20 flex items-center justify-center" data-id="element-6378">
                    <WrenchIcon size={14} className="text-blue-400" data-id="element-6379" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6380">
                    Improvements
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6381">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6382">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6383"></span>
                    Redesigned company information header with distribution
                    country selector
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6384">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6385"></span>
                    Sprinkler section reorganized with separate regulator
                    preferences
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6386">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6387"></span>
                    Billing country moved to Billing Address tab for better data
                    organization
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6388">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-blue-400 flex-shrink-0" data-id="element-6389"></span>
                    Improved sidebar navigation with version tracking
                  </li>
                </ul>
              </div>

              {/* Bug Fixes */}
              <div data-id="element-6390">
                <div className="flex items-center gap-2 mb-3" data-id="element-6391">
                  <div className="w-7 h-7 rounded-lg bg-amber-500/20 flex items-center justify-center" data-id="element-6392">
                    <BugIcon size={14} className="text-amber-400" data-id="element-6393" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6394">
                    Bug Fixes
                  </h3>
                </div>
                <ul className="space-y-2 ml-9" data-id="element-6395">
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6396">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6397"></span>
                    Fixed logo upload preview not updating correctly on first
                    upload
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6398">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6399"></span>
                    Resolved dropdown styling inconsistencies in dark mode
                  </li>
                  <li className="text-sm text-blue-200/80 flex items-start gap-2" data-id="element-6400">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-amber-400 flex-shrink-0" data-id="element-6401"></span>
                    Fixed quote calculation rounding errors on certain mark-up
                    values
                  </li>
                </ul>
              </div>

              {/* Community Contributors */}
              <div data-id="element-6402">
                <div className="flex items-center gap-2 mb-3" data-id="element-6403">
                  <div className="w-7 h-7 rounded-lg bg-pink-500/20 flex items-center justify-center" data-id="element-6404">
                    <HeartIcon size={14} className="text-pink-400" data-id="element-6405" />
                  </div>
                  <h3 className="text-white font-semibold text-sm" data-id="element-6406">
                    Community Contributors
                  </h3>
                </div>
                <p className="text-xs text-blue-300/60 ml-9 mb-3" data-id="element-6407">
                  Thanks to the users who shared feedback and helped shape this
                  release.
                </p>
                <div className="ml-9 space-y-2.5" data-id="element-6408">
                  <div className="flex items-center gap-2.5" data-id="element-6409">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-6410">
                      <span className="text-[10px] font-bold text-white" data-id="element-6411">
                        MR
                      </span>
                    </div>
                    <div data-id="element-6412">
                      <span className="text-sm text-white font-medium" data-id="element-6413">
                        Miguel Rodríguez
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6414">
                        — Sprinkler section reorganization
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2.5" data-id="element-6415">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center flex-shrink-0" data-id="element-6416">
                      <span className="text-[10px] font-bold text-white" data-id="element-6417">
                        AK
                      </span>
                    </div>
                    <div data-id="element-6418">
                      <span className="text-sm text-white font-medium" data-id="element-6419">
                        Anna Kovalenko
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6420">
                        — Billing address improvements
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2.5" data-id="element-6421">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center flex-shrink-0" data-id="element-6422">
                      <span className="text-[10px] font-bold text-white" data-id="element-6423">
                        JL
                      </span>
                    </div>
                    <div data-id="element-6424">
                      <span className="text-sm text-white font-medium" data-id="element-6425">
                        José López
                      </span>
                      <span className="text-xs text-blue-300/60 ml-2" data-id="element-6426">
                        — Quote mark-up per customer feature
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-6 py-3 border-t border-white/10 flex-shrink-0 bg-black/20" data-id="element-6427">
              <p className="text-xs text-blue-300/50 text-center" data-id="element-6428">
                Have feedback? Let us know through Customer Support
              </p>
            </div>
          </div>
        </div>}
    </div>;
}
function UserAvatarMenu({
  collapsed,
  onNavigate,
  activePage
}) {
  const {
    role: userRole,
    name: userName,
    email: userEmail
  } = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [unitsOpen, setUnitsOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[1]); // Spanish default
  const [selectedUnit, setSelectedUnit] = useState(unitSystems[0]); // Metric default
  const menuRef = useRef<HTMLDivElement>(null);
  // Determine if company info should be read-only based on role
  const isReadOnly = userRole === 'dealer' || userRole === 'customer' || userRole === 'authenticated-public-user';
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        setLanguageOpen(false);
        setUnitsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setLanguageOpen(false);
      setUnitsOpen(false);
    }
  };
  const handleSelectLanguage = (lang: (typeof languages)[0]) => {
    setSelectedLanguage(lang);
    setLanguageOpen(false);
  };
  const handleSelectUnit = (unit: (typeof unitSystems)[0]) => {
    setSelectedUnit(unit);
    setUnitsOpen(false);
  };
  return <>
      <div className="relative px-3 py-4 mt-auto border-t border-blue-800/30" ref={menuRef} data-id="element-6429">
        {/* Avatar trigger */}
        <button onClick={handleToggle} className={`w-full flex items-center rounded-lg px-2 py-2 transition-colors hover:bg-white/10 ${isOpen ? 'bg-white/10' : ''} ${collapsed ? 'justify-center' : ''}`} aria-label="User menu" aria-expanded={isOpen} aria-haspopup="true" data-id="element-6430">
          <div className="relative flex-shrink-0" data-id="element-6431">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center ring-2 ring-blue-400/30 shadow-lg" data-id="element-6432">
              <span className="text-sm font-bold text-white" data-id="element-6433">DA</span>
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 rounded-full border-2 border-blue-950" data-id="element-6434" />
          </div>
          {!collapsed && <div className="ml-3 flex-1 text-left min-w-0" data-id="element-6435">
              <p className="text-sm font-semibold text-white truncate leading-tight" data-id="element-6436">
                {userName}
              </p>
              <p className="text-xs text-blue-300 truncate leading-tight" data-id="element-6437">
                {userRole.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </p>
            </div>}
          {!collapsed && <ChevronUpIcon size={16} className={`text-blue-300 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-6438" />}
        </button>

        {/* Popover Menu — opens to the right of the sidebar */}
        {isOpen && <div className="absolute bottom-0 left-full ml-2 w-72 bg-[#0f1d3a] rounded-xl shadow-2xl border border-white/10 z-[100] overflow-hidden" data-id="element-6439">
            {/* User Info Header */}
            <div className="px-4 pt-4 pb-3 border-b border-white/10" data-id="element-6440">
              <div className="flex items-start" data-id="element-6441">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center ring-2 ring-blue-400/20 flex-shrink-0" data-id="element-6442">
                  <span className="text-base font-bold text-white" data-id="element-6443">DA</span>
                </div>
                <div className="ml-3 min-w-0 flex-1" data-id="element-6444">
                  <p className="text-sm font-semibold text-white truncate" data-id="element-6445">
                    {userName}
                  </p>
                  <p className="text-xs text-blue-300 truncate" data-id="element-6446">{userEmail}</p>
                  <span className="inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-teal-500/20 text-teal-300 border border-teal-500/30" data-id="element-6447">
                    {userRole.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                  </span>
                </div>
                <button className="p-1.5 rounded-lg hover:bg-white/10 transition-colors text-blue-400 hover:text-white flex-shrink-0 mt-0.5" onClick={() => {
              setIsOpen(false);
              setProfileModalOpen(true);
            }} title="Edit profile" data-id="element-6448">
                  <PencilIcon size={14} data-id="element-6449" />
                </button>
              </div>
            </div>

            {/* Company Info */}
            <div className="px-4 py-3 border-b border-white/10" data-id="element-6450">
              <div className="flex items-center justify-between" data-id="element-6451">
                <div className="flex items-center min-w-0" data-id="element-6452">
                  <div className="w-8 h-8 rounded-lg bg-blue-600/20 flex items-center justify-center flex-shrink-0" data-id="element-6453">
                    <BuildingIcon size={16} className="text-blue-400" data-id="element-6454" />
                  </div>
                  <div className="ml-2.5 min-w-0" data-id="element-6455">
                    <p className="text-xs text-blue-400 leading-tight" data-id="element-6456">
                      Company
                    </p>
                    <p className="text-sm font-semibold text-white truncate leading-tight" data-id="element-6457">
                      ZEPPELIN
                    </p>
                  </div>
                </div>
                <button className="p-1.5 rounded-lg hover:bg-white/10 transition-colors text-blue-400 hover:text-white flex-shrink-0" onClick={() => {
              setIsOpen(false);
              setCompanyModalOpen(true);
            }} title="Edit company" data-id="element-6458">
                  <PencilIcon size={14} data-id="element-6459" />
                </button>
              </div>
            </div>

            {/* Menu Items */}
            <div className="py-1.5" data-id="element-6460">
              {/* Language Selector */}
              <div className="relative" data-id="element-6461">
                <button className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
              setLanguageOpen(!languageOpen);
              setUnitsOpen(false);
            }} data-id="element-6462">
                  <div className="flex items-center" data-id="element-6463">
                    <GlobeIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6464" />
                    Language
                  </div>
                  <div className="flex items-center" data-id="element-6465">
                    <span className="text-xs text-blue-300 mr-1.5" data-id="element-6466">
                      {selectedLanguage.flag} {selectedLanguage.name}
                    </span>
                    <ChevronRightIconSmall open={languageOpen} data-id="element-6467" />
                  </div>
                </button>
                {languageOpen && <div className="mx-2 mb-1 rounded-lg bg-white/5 border border-white/10 overflow-hidden" data-id="element-6468">
                    {languages.map(lang => <button key={lang.code} className="w-full flex items-center px-4 py-2 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => handleSelectLanguage(lang)} data-id="element-6469">
                        <span className="mr-2.5 text-base" data-id="element-6470">{lang.flag}</span>
                        <span className="flex-1 text-left" data-id="element-6471">{lang.name}</span>
                        {selectedLanguage.code === lang.code && <CheckIcon size={14} className="text-teal-400 flex-shrink-0" data-id="element-6472" />}
                      </button>)}
                  </div>}
              </div>

              {/* Unit System Selector */}
              <div className="relative" data-id="element-6473">
                <button className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
              setUnitsOpen(!unitsOpen);
              setLanguageOpen(false);
            }} data-id="element-6474">
                  <div className="flex items-center" data-id="element-6475">
                    <RulerIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6476" />
                    Units
                  </div>
                  <div className="flex items-center" data-id="element-6477">
                    <span className="text-xs text-blue-300 mr-1.5" data-id="element-6478">
                      {selectedUnit.name}
                    </span>
                    <ChevronRightIconSmall open={unitsOpen} data-id="element-6479" />
                  </div>
                </button>
                {unitsOpen && <div className="mx-2 mb-1 rounded-lg bg-white/5 border border-white/10 overflow-hidden" data-id="element-6480">
                    {unitSystems.map(unit => <button key={unit.id} className="w-full flex items-center px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => handleSelectUnit(unit)} data-id="element-6481">
                        <div className="flex-1 text-left" data-id="element-6482">
                          <span data-id="element-6483">{unit.name}</span>
                          <span className="ml-2 text-xs text-blue-400" data-id="element-6484">
                            {unit.id === 'metric' ? 'm, ha, l/s' : 'ft, acre, GPM'}
                          </span>
                        </div>
                        {selectedUnit.id === unit.id && <CheckIcon size={14} className="text-teal-400 flex-shrink-0" data-id="element-6485" />}
                      </button>)}
                  </div>}
              </div>

              <div className="my-1 mx-3 border-t border-white/10" data-id="element-6486" />

              {/* Settings */}
              <button className="w-full flex items-center px-4 py-2.5 text-sm text-blue-100 hover:bg-white/10 transition-colors" onClick={() => {
            setIsOpen(false);
            onNavigate('settings');
          }} data-id="element-6487">
                <SettingsIcon size={16} className="mr-3 text-blue-400 flex-shrink-0" data-id="element-6488" />
                Settings
              </button>

              {/* Sign Out */}
              <button className="w-full flex items-center px-4 py-2.5 text-sm text-red-300 hover:bg-red-500/10 transition-colors" onClick={() => {
            setIsOpen(false);
          }} data-id="element-6489">
                <LogOutIcon size={16} className="mr-3 text-red-400 flex-shrink-0" data-id="element-6490" />
                Sign out
              </button>
            </div>
          </div>}
      </div>

      <EditProfileModal isOpen={profileModalOpen} onClose={() => setProfileModalOpen(false)} data-id="element-6491" />
      <EditCompanyModal isOpen={companyModalOpen} onClose={() => setCompanyModalOpen(false)} readOnly={isReadOnly} data-id="element-6492" />
    </>;
}
function ChevronRightIconSmall({
  open
}: {
  open: boolean;
}) {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`text-blue-400 transition-transform duration-200 ${open ? 'rotate-90' : ''}`} data-id="element-6493">
      <polyline points="9 18 15 12 9 6" data-id="element-6494" />
    </svg>;
}
function SidebarItem({
  icon,
  label,
  active = false,
  onClick,
  collapsed
}) {
  return <div className={`flex items-center px-3 py-2 my-1 rounded ${active ? 'bg-blue-800' : 'hover:bg-blue-800/50'} cursor-pointer transition-colors ${collapsed ? 'justify-center' : ''}`} onClick={onClick} title={collapsed ? label : ''} data-id="element-6495">
      <div className={`${collapsed ? '' : 'mr-3'} text-gray-300 flex-shrink-0`} data-id="element-6496">
        {icon}
      </div>
      {!collapsed && <span className="text-sm whitespace-nowrap truncate" data-id="element-6497">{label}</span>}
    </div>;
}
// Add custom CSS to hide scrollbar but maintain functionality
const style = document.createElement('style');
style.textContent = `
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
document.head.appendChild(style);